import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../../Include/Footer";
import Loader from "../../../Include/Loader";
import { getParty } from "../../../../../Store/Store/Party/Party";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import toast from "react-hot-toast";
import { V_URL } from "../../../../../BaseUrl";
import axios from "axios";
import { getItem } from "../../../../../Store/Store/Item/Item";
import { getStorePayment } from "../../../../../Store/Store/StoreMaster/PaymentMethod/getPaymentList";
import ReactQuill from "react-quill";
import { normalize, quillFormats, quillModules } from "../../../../../helper/quotation";
import { getQuotation } from "../../../../../Store/Store/StoreMaster/Quotation/getQuotationList";
import { Dropdown } from "primereact/dropdown";
import { getAmendData, resetAmendData } from "../../../../../Store/prosafe/proTransaction/PurOrder/getAmendData";
import AmendPurPoItems from "./components/AmendPurPoItems";
import AmendHistoryModal from "./components/AmendHistoryModal";

const initialForm = {
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    master_id: "",
    party_id: "",
    project_id: "",
    payment_method_id: "",
    quotation_id: "",
    freight_amount: "",
    remarks: "",
    amendment_reason: "",
}

const AmendPurOrder = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state: data } = useLocation();
    const [disable, setDisable] = useState(false);
    const [error, setError] = useState({});
    const [form, setForm] = useState(initialForm);

    const [itemsArr, setItemsArr] = useState([]);
    const [originalItems, setOriginalItems] = useState([]);
    const [originalForm, setOriginalForm] = useState(null);
    const [termsCondition, setTermsCondition] = useState("");
    const [isItemsLoaded, setIsItemsLoaded] = useState(false);
    const [isFormLoaded, setIsFormLoaded] = useState(false);
    const [lastPoId, setLastPoId] = useState(null);
    const [showHistory, setShowHistory] = useState(false);

    const itemData = useSelector((state) => state.getItem?.user?.data) || [];
    const orderByData = useSelector((state) => state.getGenMaster?.user?.data) || [];
    const projectData = useSelector((state) => state.getProject?.user?.data) || [];
    const partyData = useSelector((state) => state.getParty?.user?.data) || [];
    const getPaymentData = useSelector((state) => state?.getPaymentList?.user?.data?.list) || [];
    const quotationData = useSelector((state) => state?.getQuotationData?.user?.data) || [];

    useEffect(() => {
        dispatch(getGenMaster({ tag_id: 10 }));
        dispatch(getProject());
        dispatch(getParty({ is_main: true }));
        dispatch(getItem({ is_main: true }));
        dispatch(getStorePayment({ status: "true" }));
        dispatch(getQuotation());
    }, [dispatch]);

    useEffect(() => {
        if (data?._id && data?._id !== lastPoId) {
            dispatch(resetAmendData());
            setIsFormLoaded(false);
            setIsItemsLoaded(false);
            setLastPoId(data?._id);
            dispatch(getAmendData(data?._id));
        }
    }, [dispatch, data?._id, lastPoId]);

    useEffect(() => {
        return () => {
            dispatch(resetAmendData());
        };
    }, []);

    const amendData = useSelector((state) => state?.getAmendData?.user?.data);
    const isPoLoading = useSelector((state) => state?.getAmendData?.loading);

    useEffect(() => {
        if (amendData && !isFormLoaded) {
            const initialForm = {
                trans_date: moment(amendData?.trans_date).format("YYYY-MM-DD"),
                master_id: amendData?.master_id,
                project_id: amendData?.project_id,
                party_id: amendData?.party_id,
                payment_method_id: amendData?.payment_method_id,
                quotation_id: amendData?.quotation_id,
                freight_amount: amendData?.freight_amount,
                remarks: amendData?.remarks || "",
                amendment_reason: "",
            };
            setForm(initialForm);
            setOriginalForm(initialForm);
            setTermsCondition(amendData?.termsCondition || "");
            setIsFormLoaded(true);
        }
    }, [amendData, isFormLoaded]);

    useEffect(() => {
        if (amendData?.items_details?.length > 0 && !isItemsLoaded) {
            const items = amendData?.items_details?.map((item) => ({
                ...item,
                unit: item.unit_name,
                category: item.category_name,
                original_qty: item.quantity,
                isExisting: true,
            }));
            setItemsArr(items);
            setOriginalItems(JSON.parse(JSON.stringify(items)));
            setIsItemsLoaded(true);
        }
    }, [amendData, isItemsLoaded]);

    const breadcrumbItems = [
        { label: "Dashboard", link: "/main-store/user/dashboard" },
        {
            label: "Purchase Order",
            link: "/main-store/user/purchase-order-management",
        },
        { label: "Amend Purchase Order", active: true },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        if (error[name]) {
            setError((prev) => {
                const newError = { ...prev };
                delete newError[name];
                return newError;
            });
        }
    };

    const isQuillBlank = (value) => {
        const text = value.replace(/<[^>]+>/g, "").trim();
        return text.length === 0;
    };

    const validateForm = () => {
        const newErrors = {};
        const itemErrors = {};

        if (!form.amendment_reason) {
            newErrors.amendment_reason = "Amendment reason is required";
        }
        if (!form.party_id) {
            newErrors.party_id = "Party is required";
        }
        if (isQuillBlank(termsCondition)) {
            newErrors.terms_err = "Terms and Conditions can't be empty";
        }

        if (itemsArr.length === 0) {
            newErrors.items_general = "At least one item required";
            toast.error("At Least One Item is required");
        } else {
            itemsArr.forEach((item, index) => {
                const rowError = {};

                const qty = Number(item.quantity);
                const rate = Number(item.rate);

                if (!item.item_id) {
                    rowError.item_id = "Item is required";
                }

                if (
                    item.quantity === undefined ||
                    item.quantity === null ||
                    item.quantity === "" ||
                    isNaN(qty) ||
                    qty <= 0
                ) {
                    rowError.quantity = "Qty must be a valid number > 0";
                }

                if (
                    item.rate === undefined ||
                    item.rate === null ||
                    item.rate === "" ||
                    isNaN(rate) ||
                    rate <= 0
                ) {
                    rowError.rate = "Rate must be a valid number > 0";
                }

                if (Object.keys(rowError).length > 0) {
                    itemErrors[index] = rowError;
                }
            });
        }

        if (Object.keys(itemErrors).length > 0) {
            newErrors.items = itemErrors;
        }

        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const isFormFieldChanged = (fieldName) => {
        if (!originalForm) return false;
        const currentVal = form[fieldName] === null || form[fieldName] === undefined ? "" : form[fieldName];
        const originalVal = originalForm[fieldName] === null || originalForm[fieldName] === undefined ? "" : originalForm[fieldName];
        return String(currentVal) != String(originalVal);
    };

    const handleSubmit = () => {
        if (!validateForm()) return;

        const hasInvalidItems = itemsArr.some((item) => {
            const qty = Number(item.quantity);
            const rate = Number(item.rate);

            return (
                !item.item_id ||
                isNaN(qty) || qty <= 0 ||
                isNaN(rate) || rate <= 0
            );
        });

        if (hasInvalidItems) {
            toast.error("All items must have valid Qty and Rate");
            return;
        }

        setDisable(true);
        const myurl = `${V_URL}/prosafe/po/amend-po`;

        const added_items = itemsArr.filter((item) => item.isNew);
        const removed_item_ids = originalItems
            .filter((orig) => !itemsArr.find((item) => item._id === orig._id))
            .map((orig) => orig._id);

        const modified_items = itemsArr
            .filter((item) => item.isExisting)
            .filter((item) => {
                const orig = originalItems.find((o) => o._id === item._id);
                if (!orig) return false;
                return (
                    normalize(item?.item_id) !== normalize(orig?.item_id) ||
                    normalize(item?.quantity) !== normalize(orig?.quantity) ||
                    normalize(item?.rate) !== normalize(orig?.rate) ||
                    normalize(item?.discount) !== normalize(orig?.discount) ||
                    normalize(item?.gst) !== normalize(orig?.gst) ||
                    normalize(item?.remarks) !== normalize(orig?.remarks) ||
                    normalize(item?.item_no) !== normalize(orig?.item_no) ||
                    normalize(item?.item_weight) !== normalize(orig?.item_weight) ||
                    normalize(item?.mrp) !== normalize(orig?.mrp) ||
                    normalize(item?.amount) !== normalize(orig?.amount) ||
                    normalize(item?.discount_amount) !== normalize(orig?.discount_amount) ||
                    normalize(item?.taxable_amount) !== normalize(orig?.taxable_amount) ||
                    normalize(item?.gst_amount) !== normalize(orig?.gst_amount) ||
                    normalize(item?.total_amount) !== normalize(orig?.total_amount)
                );
            })
            .map((item) => {
                const orig = originalItems.find((o) => o._id === item._id);
                const modifiedFields = { _id: item._id };
                if (item.quantity !== orig.quantity) modifiedFields.quantity = item.quantity;
                if (item.item_id !== orig.item_id) modifiedFields.item_id = item.item_id;
                if (item.rate !== orig.rate) modifiedFields.rate = item.rate;
                if (item.discount !== orig.discount) modifiedFields.discount = item.discount;
                if (item.gst !== orig.gst) modifiedFields.gst = item.gst;
                if (item.remarks !== orig.remarks) modifiedFields.remarks = item.remarks;
                if (item.item_no !== orig.item_no) modifiedFields.item_no = item.item_no;
                if (item.item_weight !== orig.item_weight) modifiedFields.item_weight = item.item_weight;
                if (item.mrp !== orig.mrp) modifiedFields.mrp = item.mrp;
                if (item.amount !== orig.amount) modifiedFields.amount = item.amount;
                if (item.discount_amount !== orig.discount_amount) modifiedFields.discount_amount = item.discount_amount;
                if (item.taxable_amount !== orig.taxable_amount) modifiedFields.taxable_amount = item.taxable_amount;
                if (item.gst_amount !== orig.gst_amount) modifiedFields.gst_amount = item.gst_amount;
                if (item.total_amount !== orig.total_amount) modifiedFields.total_amount = item.total_amount;
                return modifiedFields;
            });

        const payload = {
            ...(isFormFieldChanged("party_id") && { party_id: form.party_id ?? "" }),
            ...(isFormFieldChanged("payment_method_id") && { payment_method_id: form.payment_method_id ?? "" }),
            ...(isFormFieldChanged("project_id") && { project_id: form.project_id ?? "" }),
            ...(isFormFieldChanged("master_id") && { master_id: form.master_id ?? "" }),
            ...(isFormFieldChanged("quotation_id") && { quotation_id: form.quotation_id ?? "" }),
            ...(isFormFieldChanged("freight_amount") && { freight_amount: form.freight_amount ?? "" }),
            ...(isFormFieldChanged("remarks") && { remarks: form.remarks ?? "" }),

            ...(isFormFieldChanged("trans_date") && {
                trans_date: form.trans_date ? moment(form.trans_date).format("YYYY-MM-DD") : "",
            }),

            ...(termsCondition !== (amendData?.termsCondition || "") && {
                terms_condition: termsCondition,
            }),

            po_id: data?._id,
            amendment_reason: form.amendment_reason,
            amended_by: localStorage.getItem("PAY_USER_ID"),
            modified_items: modified_items,
            added_items: added_items,
            removed_item_ids: removed_item_ids,
        };

        axios({
            method: "post",
            url: myurl,
            data: payload,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
            },
        })
            .then((response) => {
                if (response.data.success === true) {
                    toast.success(response?.data?.message);
                    navigate("/main-store/user/purchase-order-management");
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Something went wrong");
            })
            .finally(() => {
                setDisable(false);
            });
    };

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleReset = () => {
        setForm(initialForm);
        setItemsArr([]);
        setError({});
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <Breadcrumb items={breadcrumbItems} />

                    {isPoLoading ? (
                        <Loader />
                    ) : (
                        <>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card shadow-sm border-0 mb-4">
                                        <div className="card-body">
                                            <div className="form-heading border-bottom pb-2 mb-4 d-flex justify-content-between align-items-center">
                                                <h4 className="fw-bold text-primary mb-0">Amend Purchase Order Details</h4>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm rounded-pill px-3"
                                                    onClick={() => setShowHistory(true)}
                                                >
                                                    <i className="fa fa-history me-1"></i> View History
                                                </button>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-md-4">
                                                    <div className="input-block local-forms">
                                                        <label className="text-muted fw-bold">Order No.</label>
                                                        <input
                                                            type="text"
                                                            className="form-control bg-light"
                                                            value={data?.voucher_no || ""}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-block local-forms">
                                                        <label className="fw-bold">
                                                            Amendment Reason <span className="login-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            name="amendment_reason"
                                                            rows={3}
                                                            className="form-control"
                                                            placeholder="Why is this PO being amended?"
                                                            value={form.amendment_reason}
                                                            onChange={handleChange}
                                                        />
                                                        {error.amendment_reason && <small className="text-danger d-block">{error.amendment_reason}</small>}
                                                        {isFormFieldChanged("amendment_reason") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="input-block local-forms custom-select-wpr">
                                                        <label className="fw-bold">
                                                            Party <span className="login-danger">*</span>
                                                        </label>
                                                        <Dropdown
                                                            value={form.party_id}
                                                            options={partyData?.map((e) => ({
                                                                label: e.name,
                                                                value: e._id,
                                                            }))}
                                                            onChange={(e) =>
                                                                handleChange({ target: { name: "party_id", value: e.value } })
                                                            }
                                                            placeholder="Select Party"
                                                            showClear
                                                            filter
                                                            className="w-100"
                                                        />
                                                        <span className="text-muted small">
                                                            Note: Changing the party will disconnect all linked Purchase Receiving records. Proceed with caution.
                                                        </span>
                                                        {error.party_id && <small className="text-danger d-block">{error.party_id}</small>}
                                                        {isFormFieldChanged("party_id") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="input-block local-forms custom-select-wpr">
                                                        <label className="fw-bold">Payment Method</label>
                                                        <Dropdown
                                                            value={form.payment_method_id}
                                                            options={getPaymentData?.map((e) => ({
                                                                label: e.name,
                                                                value: e._id,
                                                            }))}
                                                            onChange={(e) =>
                                                                handleChange({
                                                                    target: { name: "payment_method_id", value: e.value },
                                                                })
                                                            }
                                                            placeholder="Select Payment Method"
                                                            filter
                                                            showClear
                                                            className="w-100"
                                                        />
                                                        {isFormFieldChanged("payment_method_id") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="input-block local-forms">
                                                        <label className="fw-bold">Date</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="trans_date"
                                                            onChange={handleChange}
                                                            value={form.trans_date}
                                                        />
                                                        {isFormFieldChanged("trans_date") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="input-block local-forms custom-select-wpr">
                                                        <label className="fw-bold">Ordered By</label>
                                                        <Dropdown
                                                            value={form.master_id}
                                                            options={orderByData?.map((e) => ({
                                                                label: e.name,
                                                                value: e._id,
                                                            }))}
                                                            onChange={(e) =>
                                                                handleChange({
                                                                    target: { name: "master_id", value: e.value },
                                                                })
                                                            }
                                                            placeholder="Select Ordered By"
                                                            showClear
                                                            filter
                                                            className="w-100"
                                                        />
                                                        {isFormFieldChanged("master_id") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="input-block local-forms custom-select-wpr">
                                                        <label className="fw-bold">Quotation No</label>
                                                        <Dropdown
                                                            value={form.quotation_id}
                                                            options={quotationData?.map((e) => ({
                                                                label: e.voucher_no,
                                                                value: e._id,
                                                            }))}
                                                            onChange={(e) =>
                                                                handleChange({
                                                                    target: { name: "quotation_id", value: e.value },
                                                                })
                                                            }
                                                            showClear
                                                            placeholder="Select Quotation No"
                                                            filter
                                                            className="w-100"
                                                        />
                                                        {isFormFieldChanged("quotation_id") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="input-block local-forms">
                                                        <label className="fw-bold">Freight Amount (₹)</label>
                                                        <input
                                                            type="number"
                                                            name="freight_amount"
                                                            className="form-control"
                                                            placeholder="Freight amount"
                                                            value={form.freight_amount}
                                                            onChange={handleChange}
                                                        />
                                                        {isFormFieldChanged("freight_amount") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="input-block local-forms">
                                                        <label className="fw-bold">Remarks</label>
                                                        <textarea
                                                            name="remarks"
                                                            className="form-control"
                                                            rows={2}
                                                            value={form.remarks}
                                                            onChange={handleChange}
                                                        />
                                                        {isFormFieldChanged("remarks") && <small className="text-danger d-block">changed</small>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <AmendPurPoItems
                                itemsArr={itemsArr}
                                setItemsArr={setItemsArr}
                                itemData={itemData}
                                originalItems={originalItems}
                                error={error.items || {}}
                            />

                            {/* Terms and condition section  */}
                            <div className="row mb-3">
                                <div className="col-12 ">
                                    <div
                                        className="card shadow-sm h-100"
                                        style={{ border: "1px solid #e0e0e0" }}
                                    >
                                        <div
                                            className="card-header"
                                            style={{
                                                backgroundColor: "white",
                                                border: "1px solid var(--primary-clr)",
                                                color: "var(--primary-clr)",
                                            }}
                                        >
                                            <h6
                                                className="mb-0 fw-semibold"
                                                style={{ color: "var(--primary-clr)", fontSize: "15px" }}
                                            >
                                                <i
                                                    className="fa fa-file-text me-2"
                                                    style={{ color: "var(--primary-clr)" }}
                                                ></i>
                                                Terms and Conditions <span className="text-danger">*</span>
                                            </h6>
                                        </div>

                                        <div
                                            className="card-body p-0 terms-editor-wrapper"
                                            style={{ height: "300px", overflow: "hidden" }}
                                        >
                                            <ReactQuill
                                                theme="snow"
                                                value={termsCondition}
                                                onChange={(value) => {
                                                    setTermsCondition(value);
                                                    if (error.terms_err) {
                                                        setError((prev) => {
                                                            const newErr = { ...prev };
                                                            delete newErr.terms_err;
                                                            return newErr;
                                                        });
                                                    }
                                                }}
                                                modules={quillModules}
                                                formats={quillFormats}
                                                style={{ height: "280px" }}
                                            />
                                            {error.terms_err && (
                                                <div className="error">{error.terms_err}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="col-12 text-end">
                                                <div className="doctor-submit text-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary submit-form me-2"
                                                        onClick={handleSubmit}
                                                        disabled={disable}
                                                    >
                                                        {disable
                                                            ? "Processing..."
                                                            : "Submit"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary cancel-form"
                                                        onClick={handleReset}
                                                    >
                                                        Reset
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                    )}
                </div>

                <AmendHistoryModal
                    visible={showHistory}
                    onHide={() => setShowHistory(false)}
                    poId={data?.original_po_id}
                    voucherNo={data?.voucher_no}
                />

                <Footer />
            </div >
        </div >
    );
};

export default AmendPurOrder;
